<template>
  <div>
    <div class="distance_form distance_form__reverse">
      <div
        v-b-toggle.distanceDescription
        class="distance_form__button"
        @click="toggleCollapsed('distanceDescription')"
      >
        <span
          class="distance_title"
        >Дополнительная информация о дистаниции</span>
        <span>{{ collapsedStates.distanceDescription ? '🔼' : '🔽' }}</span>
      </div>
      <b-collapse id="distanceDescription">
        <label
          for="distanceDescription"
          class="distance_label"
        >Описание дистанции</label>
        <b-form-input
          id="distanceDescription"
          v-model="distance.description"
          placeholder="Описание"
          vs-placeholder="Описание"
          class="distance_input__description"
        />
        <label
          for="distanceEventDate"
          class="distance_label"
        >Дата проведения дистанции</label>
        <flat-pickr
          id="distanceEventDate"
          v-model="distance.event_date"
          placeholder="Дата проведения дистанции"
          class="form-control distance_input__description"
          :config="{
            ...config,
            enableTime: false,
            altFormat: 'd.m.Y',
            defaultHour: 0,
            defaultMinute: 0,
          }"
        />
        <label
          for="distanceLengthM"
          class="distance_label"
        >Длина для статистики результатов, м</label>
        <b-form-input
          id="distanceLengthM"
          v-model.number="distance.length_m"
          type="number"
          min="1"
          placeholder="Если в названии нет длины — например, «Дети» или «Большой»"
          class="distance_input__description"
        />
        <label
          for="distancePrice"
          class="distance_label"
        >Цена дистанции</label>
        <price-input-wrapper
          id="distancePrice"
          :value="distance.static_price"
          @input="value => (distance.static_price = value)"
        />
      </b-collapse>
    </div>
    <div class="distance_form">
      <div class="price">
        <div
          v-b-toggle.price
          class="distance_form__button"
          @click="toggleCollapsed('price')"
        >
          <span class="distance_title"> Дополнительные цены </span>
          <span>{{ collapsedStates.price ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="price">
          <div class="price__items">
            <div
              v-for="(item, i) in distance.date_prices"
              :key="'price_' + i"
              class="price__item"
            >
              <div class="price__item-del">
                <svg
                  v-if="!disabledDatePrices.some(e => e.id === item.id)"
                  width="10"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  class="delete-icon"
                  @click="distance.date_prices.splice(i, 1)"
                >
                  <path
                    d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                  />
                </svg>
              </div>
              <label class="distance_label">Дата начала</label>
              <flat-pickr
                v-model="item.date_from"
                placeholder="Дата начала"
                class="form-control distance_price__date"
                :config="{
                  ...config,
                  defaultHour: 0,
                }"
              />
              <label class="distance_label">Дата окончания</label>
              <flat-pickr
                v-model="item.date_to"
                placeholder="Дата окончания"
                class="form-control distance_price__date"
                :config="{
                  ...config,
                  defaultHour: 23,
                  defaultMinute: 59,
                }"
              />
              <label
                for="distanceAddPrice"
                class="distance_label"
              >Цена</label>
              <price-input-wrapper
                id="distanceAddPrice"
                :value="item.price"
                class="distance_price__value"
                @input="value => (item.price = value)"
              />
            </div>
          </div>

          <b-button
            type="submit"
            variant="primary"
            class="distance_price__button"
            @click="addPrices(distance)"
          >
            Добавить цену
          </b-button>
        </b-collapse>
      </div>
    </div>

    <div class="distance_form">
      <div
        v-b-toggle.slots
        class="distance_form__button"
        @click="toggleCollapsed('slots')"
      >
        <span class="distance_title">Необходимое количество слотов</span>
        <span>{{ collapsedStates.slots ? '🔼' : '🔽' }}</span>
      </div>
      <b-collapse id="slots">
        <div class="full-width">
          <label
            for="countSlots"
            class="distance_label"
          >Количество слотов</label>
          <div>
            <b-form-input
              id="countSlots"
              v-model.number="distance.slots"
              :disabled="distance.infinite_slots"
              placeholder="Количество слотов"
              label="Слотов:"
              class="distance_slots_input"
            />
          </div>
          <div
            class="flex"
            style="align-items: center"
          >
            <b-form-checkbox
              v-model="distance.infinite_slots"
              class="custom-control-primary"
              checked="false"
              name="check-reg"
              switch
            />
            <span class="ml-1">Неограниченное количество слотов</span>
          </div>
        </div>
      </b-collapse>
    </div>
    <div class="distance_form">
      <div
        v-b-toggle.files
        class="distance_form__button"
        @click="toggleCollapsed('files')"
      >
        <span class="distance_title">Прикрепить файл трека</span>
        <span>{{ collapsedStates.files ? '🔼' : '🔽' }}</span>
      </div>
      <b-collapse id="files">
        <label class="distance_label">Загрузка файла</label>
        <file-uploader
          v-model="distance.track_link_id"
          :default="distance.track_link"
          :accept="'.gpx,application/gpx+xml,application/xml,text/xml'"
          :allowed-extensions="['.gpx']"
          upload-endpoint="/file/upload-track"
          :stringify-last-modified="true"
        />
        <b-form-input
          v-model="distance.track_code"
          placeholder="Код виджета трека"
          class="mt-3"
        />

        <b-button
          variant="primary"
          size="sm"
          class="mt-1"
          :disabled="!distance.track_code"
          @click="showTrackPreview = !showTrackPreview"
        >
          {{ showTrackPreview ? 'Скрыть' : 'Предпросмотр' }}
        </b-button>

        <div
          v-if="showTrackPreview && distance.track_code"
          class="track-preview mt-2"
          v-html="distance.track_code"
        />
      </b-collapse>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormCheckbox,
  BButton,
  BModal,
  BFormRadio,
  BCollapse,
  VBToggle,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { Russian } from 'flatpickr/dist/l10n/ru'
import FileUploader from '../../../global-components/FileUploader'
import PriceInputWrapper from '@/global-components/PriceInputWrapper.vue'

export default {
  name: 'Distances',
  components: {
    FileUploader,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BButton,
    BModal,
    flatPickr,
    BFormRadio,
    BCollapse,
    PriceInputWrapper,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: ['distance', 'mode', 'start'],
  data() {
    return {
      disabledPrice: false,
      disabledDatePrices: [],
      config: {
        allowInput: true,
        altFormat: 'd.m.Y H:i',
        altInput: true,
        enableTime: true,
        dateFormat: 'Z',
        locale: Russian, // locale for this instance only
      },
      collapsedStates: {
        distanceDescription: false,
        price: false,
        slots: false,
        files: false,
      },
      showTrackPreview: false,
    }
  },
  created() {
    if (this.start) {
      if (this.start.disabledDistances) {
        const disableDistance = this.start.disabledDistances.find(
          e => e.uuid === this.distance.uuid,
        )
        if (disableDistance) {
          this.disabledPrice = true
          this.disabledDatePrices = disableDistance.date_prices || []
        }
      }
    }
  },
  methods: {
    toggleCollapsed(collapseId) {
      this.collapsedStates[collapseId] = !this.collapsedStates[collapseId]
    },
    addPrices(distance) {
      if (!distance.date_prices) {
        this.$set(distance, 'date_prices', [])
      }
      distance.date_prices.push({
        date_to: '',
        date_from: '',
        value: '',
      })
    },
  },
}
</script>
<style>
.distance_input__description {
  margin-bottom: 0.5rem;
}

.distance_label {
  display: block;
  font-size: 0.75rem;
  margin-bottom: unset;
  cursor: pointer;
}

.distance_title {
  display: block;
  margin-bottom: 0.5rem;
}

.distance_form {
  margin-bottom: 1rem;
}

.distance_form__reverse {
  margin-top: 1rem;
}

.distance_price__value {
  margin-bottom: 0.5rem;
  /* todo Избавиться от important */
  margin-top: unset !important;
}

/* todo Избавиться от important */
.distance_price__date {
  margin-top: unset !important;
  margin-bottom: 0.5rem;
}

.price__item-del {
  display: flex;
  align-items: center;
  justify-content: end;
}

.delete-icon {
  cursor: pointer;
  fill: #5e5873;
  transition: fill 0.2s ease; /* Плавное изменение цвета */
}

.delete-icon:hover {
  fill: #dc3545; /* Красный цвет при наведении */
}

.distance_slots_input {
  margin-bottom: 0.5rem;
}

.distance_form__button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.track-preview {
  width: fit-content;
  overflow: hidden;
  max-width: 440px;
}
</style>
